'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _AsyncTypeahead = require('react-bootstrap-typeahead/lib/AsyncTypeahead.react');

var _AsyncTypeahead2 = _interopRequireDefault(_AsyncTypeahead);

var _Menu = require('react-bootstrap-typeahead/lib/Menu.react');

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = require('react-bootstrap-typeahead/lib/MenuItem.react');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _search = require('../../redux/modules/search');

var _searchParams = require('../../utils/searchParams');

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem3 = require('react-bootstrap/lib/MenuItem');

var _MenuItem4 = _interopRequireDefault(_MenuItem3);

var _searchSuggestions = require('../../redux/modules/searchSuggestions');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _config = require('../../redux/modules/config');

var _route = require('../../redux/modules/route');

var _urls = require('../../utils/urls');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _headerSearchDropdown = require('../../redux/modules/headerSearchDropdown');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = require('react-router-redux');

var _SearchInput = require('./SearchInput.scss');

var _SearchInput2 = _interopRequireDefault(_SearchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuHeader = function MenuHeader(props) {
    return _react2.default.createElement('span', (0, _extends3.default)({}, props, { className: _SearchInput2.default['auction-house-divider'] }));
};

var SearchInput = (_dec = (0, _reactRedux.connect)(function (state) {
    var pageSize = (0, _search.getSearchPageSize)(state);
    var archivedSearchGlobalState = (0, _search.isArchivedSearch)(state);
    var baseUrl = (0, _config.getBaseUrl)(state);
    var currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
    var isOnSearchPage = currentUrl.includes('/search');
    var dropdownVisible = isOnSearchPage && archivedSearchGlobalState && (0, _headerSearchDropdown.isHeaderDropdownVisible)(state);
    var suggestions = (0, _searchSuggestions.getSearchSuggestions)(state);

    return {
        archivedSearchGlobalState: archivedSearchGlobalState,
        dropdownVisible: dropdownVisible,
        pageSize: pageSize,
        suggestions: suggestions
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        fetchSearchSuggestions: _searchSuggestions.fetchSearchSuggestions,
        push: _reactRouterRedux.push
    }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(SearchInput, _Component);

    function SearchInput(props, context) {
        (0, _classCallCheck3.default)(this, SearchInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchInput.__proto__ || (0, _getPrototypeOf2.default)(SearchInput)).call(this, props, context));

        _initialiseProps.call(_this);

        _this.state = {
            archiveSearchStatus: props.archivedSearchGlobalState,
            dropdownVisible: props.dropdownVisible,
            isMenuOpen: false,
            selected: [],
            text: ''
        };
        return _this;
    }

    (0, _createClass3.default)(SearchInput, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // hack to add enterkey listening to the typeahead
            var mainInput = document.querySelector('input[name="' + this.props.name + '"]');
            mainInput.addEventListener('keyup', this.onKeyUp);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // checking prop changes to ensure the right option on the dropdown is shown
            if (nextProps.dropdownVisible && !this.props.archivedSearchGlobalState || !nextProps.dropdownVisible && this.props.archivedSearchGlobalState) {
                this.setState({ archiveSearchStatus: nextProps.archivedSearchGlobalState });
            }

            // checking prop changes to ensure that the dropdown is still visible when you select upcoming
            if (this.state.archiveSearchStatus && !nextProps.dropdownVisible || nextProps.dropdownVisible) {
                this.setState({ dropdownVisible: true });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['archivedSearchGlobalState', 'dropdownVisible', 'className', 'forceArchiveOnly', 'name', 'pageSize', 'suggestions']) || (0, _propsComparer2.default)(this.state, nextState, ['archiveSearchStatus', 'dropdownVisible', 'isMenuOpen', 'text', 'selected']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                _props$suggestions = _props.suggestions,
                suggestions = _props$suggestions === undefined ? [] : _props$suggestions;
            var _state = this.state,
                archiveSearchStatus = _state.archiveSearchStatus,
                dropdownVisible = _state.dropdownVisible;
            var formatMessage = this.context.intl.formatMessage;


            var title = formatMessage({
                id: archiveSearchStatus ? 'search_input_sold' : 'search_input_upcoming'
            });
            var item = formatMessage({
                id: archiveSearchStatus ? 'search_input_upcoming' : 'search_input_sold'
            });

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_SearchInput2.default['search-input']]).join(' ').trim();
            var searchBarClass = dropdownVisible ? _SearchInput2.default['search-bar-input'] : _SearchInput2.default['search-bar-input-with-dropdown'];
            var extraClass = this.state.isMenuOpen ? _SearchInput2.default['remove-bottom-border'] : '';

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, dropdownVisible && (0, _jsx3.default)('div', {
                className: _SearchInput2.default['search-dropdown'] + ' ' + extraClass
            }, void 0, (0, _jsx3.default)(_DropdownButton2.default, {
                className: _SearchInput2.default['search-field-dropdown'],
                title: title,
                onSelect: this.changeSearchStatus,
                onToggle: this.onToggle,
                id: 'search-input-dropdown'
            }, '1', (0, _jsx3.default)(_MenuItem4.default, {
                eventKey: '1'
            }, void 0, item))), _react2.default.createElement(_AsyncTypeahead2.default, {
                className: searchBarClass,
                delay: 300,
                emptyLabel: '',
                filterBy: function filterBy() {
                    return true;
                },
                labelKey: 'value',
                minLength: 1,
                name: this.props.name,
                onChange: this.handleChange,
                onInputChange: this.handleInputChange,
                onSearch: this.handleSearch,
                options: this.addHousesHeader(suggestions),
                placeholder: formatMessage({
                    id: archiveSearchStatus ? 'search_input_search_past_auction_price_results' : 'search_input_search_for_items_and_auction_houses'
                }),
                promptText: '',
                ref: function ref(_ref) {
                    _this2._typeahead = _ref;
                },
                renderMenu: this.renderSuggestions,
                selected: this.state.selected,
                useCache: false
            }), (0, _jsx3.default)(_caterwaulComponents.Icon, {
                className: _SearchInput2.default['search-field-icon'],
                name: 'search',
                onClick: this.search
            }));
        }
    }]);
    return SearchInput;
}(_react.Component), _class2.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class2.defaultProps = {
    className: '',
    suggestions: []
}, _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onKeyUp = function (event) {
        if (event.keyCode === 13) {
            _this3.search();
        }
    };

    this.onToggle = function () {
        _this3.setState({
            isMenuOpen: !_this3.state.isMenuOpen
        });
    };

    this.searchPhrase = function (text) {
        text = text.replace(/"/g, '\\"');
        var searchStatus = _this3.state.archiveSearchStatus || _this3.props.forceArchiveOnly ? _searchParams.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH : _searchParams.DEFAULT_STATUS_FOR_ONLINE_SEARCH;
        var url = '?parameters=%7B"page":1,"sort":"' + _search.DEFAULT_SORT_ORDER + '","keyword":"' + encodeURIComponent(text) + '","status":"' + searchStatus + '"%7D';
        _this3.props.push({
            pathname: '/search',
            search: url
        });
        var instance = _this3._typeahead.getInstance();
        instance.blur();
    };

    this.searchHouse = function (houseId, houseName) {
        _this3.props.push({
            pathname: (0, _urls.getSellerUrl)(houseId, houseName)
        });
    };

    this.search = function () {
        var selected = _this3.state.selected.length > 0 ? _this3.state.selected[0] : null;
        if (selected) {
            if (selected.houseId) {
                _this3.searchHouse(selected.houseId, selected.value);
            } else {
                _this3.searchPhrase(selected.value);
            }
        } else {
            if (_this3.state.text.trim().length === 0) {
                return;
            }
            _this3.searchPhrase(_this3.state.text.trim());
        }
    };

    this.addHousesHeader = function (suggestions) {
        if (!suggestions || !suggestions.length) return undefined;
        if (suggestions.some(function (suggestion) {
            return suggestion.label === 'Auction Houses';
        })) return suggestions;
        var catalogIndex = suggestions.findIndex(function (result) {
            return result.houseId;
        });
        if (catalogIndex > -1) {
            suggestions.splice(catalogIndex, 0, {
                label: 'Auction Houses',
                value: 'Auction Houses'
            });
        }
        return suggestions;
    };

    this.handleChange = function (selected) {
        var selectedItem = selected && selected.length && selected[0].value ? selected[0] : null;

        if (selectedItem) {
            if (selectedItem.label === 'Auction Houses') return;
            if (selectedItem.houseId) {
                _this3.searchHouse(selectedItem.houseId, selectedItem.value);
            } else {
                _this3.searchPhrase(selectedItem.value);
            }
        }
    };

    this.handleInputChange = function (newValue) {
        _this3.setState({
            text: newValue
        });
    };

    this.handleSearch = function (query) {
        _this3.props.fetchSearchSuggestions(query);
    };

    this.buildMenuItems = function (items, term, index) {
        var menuItems = [];
        items.forEach(function (item) {
            var menuItem = (0, _jsx3.default)(_MenuItem2.default, {
                option: item,
                position: index
            }, index, (0, _jsx3.default)('span', {
                className: _SearchInput2.default['suggestions-result'],
                dangerouslySetInnerHTML: {
                    __html: item.label.replace(new RegExp('(' + term + ')', 'gi'), '<span class="' + _SearchInput2.default['query-match'] + '">$1</span>')
                }
            }));
            index += 1;
            menuItems.push(menuItem);
        });
        return menuItems;
    };

    this.changeSearchStatus = function () {
        _this3.setState({ archiveSearchStatus: !_this3.state.archiveSearchStatus });
    };

    this.renderSuggestions = function (results, props) {
        var term = _this3.state.text;
        var items = [];
        var auctionHouses = [];
        var grouped = results.reduce(function (refinedResult, result) {
            if (result.label === 'Auction Houses') return refinedResult;
            if (result.houseId) {
                refinedResult.auctionHouses.push(result);
            } else {
                refinedResult.auctionItems.push(result);
            }
            return refinedResult;
        }, { auctionHouses: [], auctionItems: [] });

        // reduce popular search suggestions for items to 5
        if (grouped.auctionItems.length > 5) {
            grouped.auctionItems = grouped.auctionItems.slice(0, 5);
        }

        items = _this3.buildMenuItems(grouped.auctionItems, term, 0);
        if (grouped.auctionHouses.length > 0) {
            var auctionHouseHeader = (0, _jsx3.default)('div', {
                className: _SearchInput2.default['auction-house-wrapper']
            }, 'auction-house-wrapper', (0, _jsx3.default)(MenuHeader, {}, 'auctionHouse' + '-header', 'Auction Houses'), (0, _jsx3.default)('span', {
                className: _SearchInput2.default['auction-house-line']
            }));

            if (!_this3.state.archiveSearchStatus) {
                var auctionHouse = _this3.buildMenuItems(grouped.auctionHouses, term, 5);
                auctionHouses = [auctionHouseHeader].concat((0, _toConsumableArray3.default)(auctionHouse));
            } else {
                auctionHouses = [];
            }
        }
        return _react2.default.createElement(
            _Menu2.default,
            props,
            [].concat((0, _toConsumableArray3.default)(items), (0, _toConsumableArray3.default)(auctionHouses))
        );
    };
}, _temp)) || _class);
exports.default = SearchInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput/SearchInput.js
// module id = LXPM
// module chunks = 46